<template>
  <auth-layout>
    <div class="c-auth-card c-signup-card">
      <div class="c-auth-card__head">
        <img src="@/assets/img/logo.svg" class="logo" alt="Sber logo">
      </div>
      <div class="c-auth-card__content">
        <div class="c-auth-card__slider">
          <transition name="fadeInOut">
            <div class="c-auth-card__slide first" v-if="steps.first">
              <h2 class="c-auth-card__title last">Регистрация</h2>
              <form method="post" @submit="signup">
                <div class="c-auth-card__body c-signup-card__body">
                  <form-control
                    :placeholder="payload.phone.placeholder"
                    :error="payload.phone.error"
                    :short="payload.phone.short"
                    :type="payload.phone.type"
                    v-model="payload.phone.value"
                    required
                    autofocus
                  />
                  <form-control
                    :placeholder="payload.password.placeholder"
                    :error="payload.password.error"
                    :short="payload.password.short"
                    :type="payload.password.type"
                    :iconType="payload.password.iconType"
                    :iconClick="togglePassword"
                    v-model="payload.password.value"
                    required
                  />
                  <form-control
                    :placeholder="payload.repeat_password.placeholder"
                    :error="payload.repeat_password.error"
                    :short="payload.repeat_password.short"
                    :type="payload.repeat_password.type"
                    v-model="payload.repeat_password.value"
                    required
                  />
                </div>

                <div class="c-auth-card__controlls c-signup-card__controlls">
                  <button type="submit" class="button button__bold">Продолжить</button>
                  <router-link to="/login" class="link link__ui">Отмена</router-link>
                </div>
              </form>
            </div>
          </transition>
          <transition name="rollUp">
            <div class="c-auth-card__slide second" v-if="steps.second">
              <h2 class="c-auth-card__title">Подтверждение регистрации</h2>
              <p class="c-auth-card__short">На номер телефона +7 (981) 342-XX-XX был выслан SMS-код подтверждения</p>
              <form method="post" @submit="smsCheckMethod">
                <div class="c-auth-card__body c-signup-card__body">
                  <form-control
                    :placeholder="smsCheck.placeholder"
                    :error="smsCheck.error"
                    :short="smsCheck.short"
                    :type="smsCheck.type"
                    v-model="smsCheck.value"
                    required
                    autofocus
                  />
                  <button type="button" class="c-signup-card__resend" @click="repeatSmsCode()">
                    <img src="@/assets/img/icons/repeat.svg" alt="">
                    <span>Выслать код повторно</span>
                  </button>
                </div>

                <div class="c-auth-card__controlls c-signup-card__controlls">
                  <button type="submit" class="button button__bold">Продолжить</button>
                  <span to="/login" class="link link__ui" @click="backToFirst()">Отмена</span>
                </div>
              </form>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "@/layouts/AuthLayout";
import FormControl from "@/components/forms/FormControl";

export default {
  data() {
    return {
      steps: {
        first: true,
        second: false
      },
      payload: {
        phone: {
          value: "",
          short: "",
          error: "",
          placeholder: "Номер мобильного телефона",
          type: "tel"
        },
        password: {
          value: "",
          short: "",
          error: "",
          placeholder: "Пароль",
          type: "password",
          iconType: "password"
        },
        repeat_password: {
          value: "",
          short: "",
          error: "",
          placeholder: "Пароль",
          type: "password"
        }
      },
      smsCheck: {
        value: "",
        short: "",
        error: "",
        placeholder: "SMS-код",
        type: "text"
      }
    };
  },
  components: {
    AuthLayout,
    FormControl
  },
  methods: {
    togglePassword(data) {
      if (data.click) {
        if (this.payload.password.type === "password") {
          this.payload.password.type = "text";
        } else {
          this.payload.password.type = "password";
        }
      }
    },
    signup(e) {
      e.preventDefault();
      console.log(e, "signup");
      this.steps.first = false;
      this.steps.second = true;
    },
    backToFirst() {
      this.smsCheck.value = "";
      this.steps.second = false;
      this.steps.first = true;
    },
    smsCheckMethod(e) {
      e.preventDefault();
      console.log(this.smsCheck, e, "checkSms");
    },
    repeatSmsCode() {
      console.log("repeat sms");
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
